<template>
  <transition
    enter-active-class="transition ease-out duration-200"
    enter-from-class="opacity-0 translate-y-1"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition ease-in duration-150"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-1"
  >
    <div v-show="isOpen">
      <slot />
    </div>
  </transition>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import type { Ref } from 'vue';

const isOpen = inject('isOpen') as Ref<boolean>;
</script>
